import { Swiper } from 'swiper';

class OfferModal {
  constructor(element) {
    if (!(element instanceof HTMLElement)) {
      throw new TypeError('Invalid element');
    }

    this.element = element;
    this.modalParent = element.closest('.modal');
    this.button = element.querySelector('.offer-content__next');
    this.innerWrapper = element.querySelector('.offer-content__inner');
    this.formWrapper = element.querySelector('.offer-content__form');
    this.initialisedForm = false;

    this.initEvent();
  }

  initEvent() {
    this.button.addEventListener('click', this.showForm.bind(this));
    window.addEventListener('promotion.closed', this.hideForm.bind(this));
    if (this.modalParent) {
      // this.modalParent.addEventListener('modal.opened', this.initSwiper.bind(this));
    }
  }

  hideForm() {
    this.innerWrapper.style.display = 'block';
    this.formWrapper.style.display = 'none';
  }

  showForm() {
    this.innerWrapper.style.display = 'none';
    this.formWrapper.style.display = 'block';

    if (!this.initialisedForm) {
      const event = new CustomEvent('init.widget', {
        detail: {
          element: this.formWrapper.querySelector('.offer-form'),
          widget: 'BookingForm',
        },
      });

      window.dispatchEvent(event);
      this.initialisedForm = true;
    }
  }
}

export default OfferModal;
